var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "digital-thermometer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDAE5",
    d: "M5,2V13a5,5,0,1,0,6,0V2ZM8,20a3,3,0,0,1-3-3,3,3,0,0,1,1.5-2.58l.5-.29V4H9V14.13l.5.29A3,3,0,0,1,11,17,3,3,0,0,1,8,20Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDAE5",
    width: 6,
    height: 2,
    x: 15,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDAE5",
    width: 6,
    height: 2,
    x: 15,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDAE5",
    width: 6,
    height: 2,
    x: 15,
    y: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.cba1fef7e4cc35cdfe218e18868018be.svg";
export { ForwardRef as ReactComponent };